import {
  ErrorPage,
  Home,
  Loading,
  NotFound,
  BasicPage,
  Search,
  IndexTemplate,
  Author,
  Gallery,
  Content,
  Spec,
  Article,
  Review,
  OwnerReview,
  IntermediaryTemplate,
} from 'Templates';

export const layouts = {
  GALLERY: Gallery,
  ARTICLE: Article,
  REVIEW: Review,
  PAGINATED_REVIEW_VERDICT: Review,
  PAGINATED_REVIEW: Review,
  OWNER_REVIEW: OwnerReview,
  NEWS: Article,
  BESTS: Article,
  INDEX_PAGE: IndexTemplate,
  HOMEPAGE: Home,
  BASIC_PAGE: BasicPage,
  TAXONOMY_INDEX: IndexTemplate,
  SEARCH_INDEX: Search,
  AUTHOR_INDEX: Author,
  INDEX_ARTICLE_PAGE: Article,
  loading: Loading,
  notFound: NotFound,
  error: ErrorPage,
  VEHICLE_SPECLIST: Spec,
  VEHICLE_SPECS: Spec,
  INTERMEDIARY_PAGE: IntermediaryTemplate,
};
